/**
 * Modal class
 * @author Tomasz Gawlik <gawlik@flipsidegroup.com>
 */
export default class Modal {
  /**
   * Contructor
   * @param arg
   */
  constructor(arg) {
    this.body = arg.body || 'No body specified';
    this.fnContinue = arg.fnContinue || (() => {});
    this.fnBack = arg.fnBack;
    this.fnOnClose = typeof arg.fnOnClose === 'function' ? arg.fnOnClose : () => {};
    this.backButtonText = arg.backButtonText || 'Edit';
    this.backButtonState = arg.backButtonState || 'enabled';
    this.closeButtonState = arg.closeButtonState || 'enabled';
    this.continueButtonText = arg.continueButtonText || 'Continue';
    this.continueButtonState = arg.continueButtonState || 'enabled';

    this.modalBg = $(
      '<div class="modal-cover position-fixed"></div>',
    );

    this.buildModal();
    this.render();
    this.utilities();
    if (!arg.closed) {
      this.open();
    }
  }

  /**
   * Build Modal
   */
  buildModal() {
    this.modal = $('<div class="modal-box"></div>');
    this.buildCloseButton();
    this.modal.append(this.body);
    this.buildButtons();
  }

  /**
   * Build buttons and place them on modal
   */
  buildButtons() {
    this.buildBackButton();
    this.buildContinueButton();
  }

  buildCloseButton() {
    if(this.closeButtonState === 'enabled') {
      this.modal.append('<button class="js-modal-close modal-close">\n'
          + '      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">\n'
          + '        <path\n'
          + '            d="M10.68289,10,20,19.31711,19.31711,20,10,10.68289.68289,20,0,19.31711,9.31711,10,0,.68289.68289,0,10,9.31711,19.31711,0,20,.68289Z"\n'
          + '            fill="#535150" opacity="0.9"/>\n'
          + '      </svg>\n'
          + '    </button>')
    }
  }

  /**
   * Prepare 'Edit' button and place it on modal
   */
  buildBackButton() {
    if(this.backButtonState === 'enabled') {
      const backButton = $('<a href="javascript:void(0)"></a>').addClass(
          'back-button',
      )
          .append([
            '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="10" viewBox="0 0 17 10">',
            '<path d="M0,5.009,4.81285.17815H7.19727L3.27858,4.13685H17v1.7073H3.24957l3.9527,3.9777H4.81285Z"/>',
            '</svg>',
            this.backButtonText,
          ].join(''));
      if (typeof this.fnBack !== 'function') {
        backButton.addClass('js-modal-close');
      } else {
        backButton.bind('click', this.fnBack);
      }
      this.modal.append(backButton);
    }
    return true;
  }

  /**
   * Prepare 'Continue' button and place it on modal
   */
  buildContinueButton() {
    if(this.continueButtonState === 'enabled') {
      const continueButton = $('<a href="javascript:void(0)"></a>').addClass(
        'button',
      ).addClass('d-inline-block').html(this.continueButtonText);
      continueButton.bind('click', this.fnContinue);
      this.modal.append(continueButton);
    }
  }

  /**
   * Render modal on body
   */
  render() {
    document.body.append(this.modalBg.get(0));
    document.body.append(this.modal.get(0));
  }

  /**
   * Open modal
   */
  open() {
    $('body').addClass('modal-open');
    this.modal.fadeIn(100);
    this.modalBg.delay(150).fadeIn(100);
  }

  /**
   * close and destroy modal
   */
  close() {
    $('body').removeClass('modal-open');
    this.fnOnClose();
    this.modal.fadeOut(100);
    this.modalBg.delay(100).fadeOut(100, () => {
      this.modal.remove();
      this.modalBg.remove();
    });
  }

  /**
   * Other magic code
   */
  utilities() {
    $('.js-modal-close').on('click', (event) => {
      event.preventDefault();
      this.close();
    });

    $('.js-modal-open').on('click', (event) => {
      event.preventDefault();
      this.open();
    });
  }
}
